exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-dialog__header-inner[data-v-3a350e07] {\n  width: 100%;\n  position: relative;\n  text-align: center;\n}\n.alert-dialog__title[data-v-3a350e07] {\n  display: inline-block;\n  padding: 0 28px;\n}\n.alert-dialog__close[data-v-3a350e07] {\n  position: absolute;\n  top: -10px;\n  right: -15px;\n  margin: 0;\n}\n.risk-dialog__message[data-v-3a350e07] {\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  color: #000;\n  white-space: pre-line;\n}\n", ""]);

// exports
